// Plain helpers — no DOM, no Stimulus, no framework.

export const DEFAULT_SLOT_MINUTES = 30;
export const DEFAULT_START_HOUR = 9;
export const DEFAULT_END_HOUR = 18;

export function parseLocalDate(dateString) {
  const [year, month, day] = dateString.split("-").map(Number);
  return new Date(year, month - 1, day);
}

export function formatDateString(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function minutesFromMidnight(isoString) {
  const [, time] = String(isoString).split("T");
  if (!time) return 0;
  const [h, m] = time.split(":").map(Number);
  return h * 60 + m;
}

export function isoFromMinutesOnDate(dateString, minutesFromMidnight) {
  const hh = String(Math.floor(minutesFromMidnight / 60)).padStart(2, "0");
  const mm = String(minutesFromMidnight % 60).padStart(2, "0");
  return `${dateString}T${hh}:${mm}:00`;
}

export function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function staffInitials(name) {
  if (!name) return "?";
  return name
    .split(/\s+/)
    .map((part) => part[0] || "")
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

// Read layout dimensions from CSS custom properties on the calendar root.
// Falling back to sensible defaults if a variable isn't set.
export function readCssLayout(element) {
  const styles = getComputedStyle(element);
  const px = (name, fallback) =>
    parseInt(styles.getPropertyValue(name), 10) || fallback;
  return {
    slotHeightPx: px("--calendar-slot-height", 48),
    timeColumnWidthPx: px("--calendar-time-column-width", 80),
    minResourceWidth: px("--calendar-min-resource-width", 180),
  };
}

// Status -> CSS variable name for the left border / accent.
// Allows consumers to override colors purely via CSS (--calendar-status-*).
export function statusCssVariable(item) {
  if (item.kind === "block") return "--calendar-block-border";
  switch (item.status) {
    case "confirmed":
      return "--calendar-status-confirmed";
    case "pending":
      return "--calendar-status-pending";
    case "completed":
      return "--calendar-status-completed";
    case "cancelled":
      return "--calendar-status-cancelled";
    default:
      return "--calendar-status-confirmed";
  }
}
